import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-257" data-mp="o7b968omkoeg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-258" data-mp="j7ourvx29242">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-259" data-mp="j9004065mhxa">Resumen final</h2>
        <p className="mt-3 text-center text-muted" data-id="element-260" data-mp="1gskxjbjhbwry">
          {productName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-deep" data-id="element-261" data-mp="16whkhan3adq8">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-262" data-mp="16uy4ll5ci4oz">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="bg-ivory flex gap-3 rounded-xl border border-line p-4 shadow-card" data-id="element-263" data-mp="12x8qq5s1ufuo">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" data-id="element-264" data-mp="3rknjtz9ynsi7" />
              <p data-id="element-265" data-mp="3njtxhac62lrf">
                <b className="block text-sm text-ink" data-id="element-266" data-mp="3nnhmbw6o2jzt">{feature}</b>
                <span className="text-sm text-muted" data-id="element-267" data-mp="3ie7j4uwwlacu">{detail}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}